<template>
  <div id="topNav" v-if="global.windowWidth && global.windowWidth < 992">
    <MobileNav />
  </div>
  <div id="topNav" v-else>
    <b-container>
      <img id="topNavLogo" src="@/assets/icons/cubs-white.png" />
      <PrimaryNav />
    </b-container>
  </div>
</template>

<script>
import PrimaryNav from "@/components/TopNav/PrimaryNav";
import MobileNav from "@/components/TopNav/MobileNav";
import { mapState } from "vuex";
export default {
  name: "TopNav",
  components: {
    PrimaryNav,
    MobileNav
  },
  mounted() {
    window.addEventListener('scroll', function (e) {
      var scrolled = window.pageYOffset;
      const background = document.getElementById('topNav');
      if(scrolled < 533){
        background.style.backgroundPositionY = -50 + (scrolled * 0.1) + 'px';
      } else {
        background.style.backgroundPositionY = 0 + 'px'
      }
    });

    let scrollpos = window.scrollY
    const header = document.getElementById("topNav")
    const header_height = header.offsetHeight

    const add_class_on_scroll = () => header.classList.add("fadeIn")
    const remove_class_on_scroll = () => header.classList.remove("fadeIn")

    window.addEventListener('scroll', function() { 
      scrollpos = window.scrollY;
      if (scrollpos >= header_height) {
        add_class_on_scroll()
      } else {
        remove_class_on_scroll()
      }
    })
  },
  computed: {
    ...mapState(["global"])
  },
  methods: {
    isMobile(width) {
      return width.windowWidth < 992;
    }
  }
};
</script>

<style lang="scss" scoped>
#topNav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1003;
  background-color: transparent;
  background-image: url("~@/assets/images/nav-bg.svg");
  background-repeat: no-repeat;
  background-position-x: 65%;
  background-position-y: -50px;
  transition: all 0.25s ease-in-out;
  &.fadeIn {
    background-color: $dark-blue;
  }
  #topNavLogo {
    width: 60px;
    top: 11px;
    left: 16vw;
    position: absolute;
    @media (max-width: $xl) {
      left: 8vw;
    }
    @media (max-width: $lg) {
      left: 4vw;
    }
  }
}
</style>